import axiosInstance from "../../../../api/axiosInstance";
import { endpoints } from "../../../../services/endpoints";
import { getUsersRequest, getUsersRequestError, getUsersRequestSuccess } from "../../../slices/teams/members/GetUsersSlice";

export const GetUsersApi = (currentPage,limit,searchTerm) => async (dispatch) => {
    const queryParams = new URLSearchParams({ currentPage: currentPage, limit: limit,searchTerm:searchTerm }).toString();

    const url = `${endpoints.UserList}?${queryParams}`;
    try {
        dispatch(getUsersRequest());
        axiosInstance({
            method: "GET",
            url: url,
            headers: { "Content-Type": "application/json" },
        })
            .then((resp) => {
                return dispatch(getUsersRequestSuccess(resp?.data));
            })
            .catch((error) => {
                const _error = {
                    data: error?.response?.data?.message || error?.message,
                    status: error?.response?.status || error?.status,
                };
                return dispatch(getUsersRequestError(_error));
            });
    } catch (error) { }
};
